// MUI components
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';
import { IconButton } from '@mui/material';

export const FilterListCnt = styled(Box)(({ theme }) => ({
  marginBottom: '10px',
  '& p+p': {
    marginTop: 2,
  },
}));

export const FilterOption = styled(Typography, {
  shouldForwardProp: (prop) => !['selected'].includes(prop),
})(({ selected, disabled }) => ({
  color: disabled ? '#8d8d99' : selected ? '#4E48FA' : '#000000',
  fontWeight: selected ? 700 : 500,
  fontSize: 14,
  padding: '8px 10px',
  borderRadius: 6,
  cursor: !disabled && 'pointer',
  width: '100%',
  background: selected ? `${disabled ? '#eeeeee' : '#EBEAFF'}` : 'transparent',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  '& svg': {
    fontSize: 20,
    opacity: 0,
    color: '#4E48FA',
  },
  '&:hover': {
    fontWeight: !disabled && 700,
    background: disabled ? '#eeeeee' : selected ? '#EBEAFF' : '#F5F5F5',
    '& svg': {
      opacity: 1,
    },
  },
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  height: 24,
  width: 24,
  '& svg': {
    fontSize: 24,
  },
}));
